// extracted by mini-css-extract-plugin
module.exports = {"best_offers":"EUBestOffers_best_offers__4smmE","flashSaleCountdown":"EUBestOffers_flashSaleCountdown__Wx1Fc"};